// Add to convex/helpers.ts or similar
export function getExperimentGroup(userId: string) {
  // Hash user ID for consistency
  const input = `${userId}`;
  const hash = input
    .split("")
    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
  const bucket = hash % 100;

  return bucket;
}
